var map = {
	"./commercial.png": 195,
	"./corcom.png": 196,
	"./distribution.png": 197,
	"./hrca.png": 198,
	"./information_technology.png": 199,
	"./internal_audit.png": 200,
	"./marketing.png": 201,
	"./product_innovation_and_development.png": 202,
	"./research_and_development.png": 203,
	"./supply_chain.png": 204,
	"./team-1.jpg": 205,
	"./team-2.jpg": 206,
	"./team-3.jpg": 207,
	"./team-4.jpg": 208,
	"./team-5.jpg": 209,
	"./team-6.jpg": 210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1338;